import React, { useState, useEffect, useCallback } from 'react';
import './Carousel.css';

const Carousel = ({ images, autoPlay = true, interval = 3000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(autoPlay);

    // 使用 useCallback 缓存函数
    const goToPrevious = useCallback(() => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    }, [currentIndex, images.length]);

    const goToNext = useCallback(() => {
        const isLastSlide = currentIndex === images.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    }, [currentIndex, images.length]);

    // 处理自动播放
    useEffect(() => {
        if (!isAutoPlaying || !autoPlay) return;

        const timer = setInterval(() => {
            goToNext();
        }, interval);

        return () => clearInterval(timer);
    }, [goToNext, isAutoPlaying, autoPlay, interval]);

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    // 添加键盘导航
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') {
                goToPrevious();
            } else if (e.key === 'ArrowRight') {
                goToNext();
            } else if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                setIsAutoPlaying(prev => !prev);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [goToPrevious, goToNext]);

    // 清理函数：停止自动播放
    useEffect(() => {
        return () => {
            // 组件卸载时清理定时器（通过 useEffect 的清理函数实现）
        };
    }, []);

    return (
        <div className="carousel">
            {/* 上一张按钮 */}
            <button className="carousel-btn prev" onClick={goToPrevious}>
                &#10094;
            </button>

            {/* 下一张按钮 */}
            <button className="carousel-btn next" onClick={goToNext}>
                &#10095;
            </button>

            {/* 轮播图片 */}
            <div className="slide-container">
                {images.map((image, index) => (
                    <div
                        key={image.id || index}
                        className={`slide ${index === currentIndex ? 'active' : ''}`}
                        style={{
                            backgroundImage: `url(${image.url})`,
                            opacity: index === currentIndex ? 1 : 0
                        }}
                    >
                        {image.title && (
                            <div className="slide-content">
                                <h3>{image.title}</h3>
                                <p>{image.description}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* 指示器 */}
            <div className="indicators">
                {images.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>

            {/* 播放/暂停按钮 */}
            {/*<button*/}
            {/*    className="play-pause-btn"*/}
            {/*    onClick={() => setIsAutoPlaying(!isAutoPlaying)}*/}
            {/*    aria-label={isAutoPlaying ? 'Pause carousel' : 'Play carousel'}*/}
            {/*>*/}
            {/*    {isAutoPlaying ? '⏸️' : '▶️'}*/}
            {/*</button>*/}
        </div>
    );
};

export default Carousel;
